import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { DATE_FORMAT_2, DATE_FORMAT_4 } from 'constants';
import cn from 'classnames';
import { TextField, Calendar as CalendarMW, DateUtils } from 'mw-style-react';
import './Calendar.scss';

/**
 * Компонент Calendar
 */
class Calendar extends PureComponent {
  render() {
    const {
      id,
      title,
      value,
      visibility,
      extra,
      error,
      getErrorMsg,
      onChange,
    } = this.props;
    const { startDate } = value;
    const displayDateFormat = extra.time ? DATE_FORMAT_4 : DATE_FORMAT_2;
    return (
      <TextField
        id={`editor_${id}`}
        bordered={true}
        styleName={cn('calendar')}
        label={title}
        visibility={visibility}
        value={startDate ? DateUtils.toDate(startDate, displayDateFormat) : ''}
        error={error}
        helperText={getErrorMsg(this.props)}
        calendar={() => (
          <CalendarMW
            id={id}
            size="small"
            minDate={extra.minDate}
            maxDate={extra.maxDate}
            time={extra.time}
            timeZone={extra.timeZone}
            value={value}
            onChange={onChange}
          />
        )}
      />
    );
  }
}

Calendar.defaultProps = {
  extra: {},
  value: {},
};

Calendar.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string,
  value: PropTypes.object,
  error: PropTypes.bool,
  visibility: PropTypes.string,
  extra: PropTypes.object,
  onChange: PropTypes.func,
  getErrorMsg: PropTypes.func,
};

export default Calendar;
